<template>
  <div class="charts-page">
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel
          class="chart-widget"
          :title="$t('graficosTransito.transitoTempoReal')">
            <div class="md12 xs12" style="position: relative;">
                <div id="divTransparente" v-bind:class="[isColapsado ? 'divColapsada' : 'divTransparente']">
                    <div class="textDivInfo">
                        <h5 style="font-size: 1.2rem" @click="toggleColapsado" id="tituloMob"> {{$t('mobilidade.tituloCongestionamento')}}
                            <vuestic-tooltip v-if="tooltipOptions" :options="tooltipOptions" class="float-right">
                                <i style="float: right" class="fa fa-question-circle-o fa-lmd toolTipHelp"></i>
                            </vuestic-tooltip>
                        </h5>
                        <va-scrollbar>
                          <div>
                            <div v-for="(con, index) in congestionamentos" :key="index"  v-show="!isColapsado">
                              <div class="componente">
                                  <span class="tituloProgress">{{con.corredor}} - {{con.sentido}} <br> <span v-bind:title="con.local" style="font-size: .7875rem; font-style: italic;"> {{con.local}}</span> </span>
                                  <va-progress-bar :value="con.tamanho_processado" color="danger"><span style="font-size: .8875rem">{{con.legenda}}</span></va-progress-bar>
                              </div>
                            </div>
                          </div>
                        </va-scrollbar>
                    </div>
                </div>
                <GmapMap
                    id="mapaTransito"
                    ref="gmap"
                    :center="this.center"
                    :zoom="this.zoom"
                    map-type-id="roadmap"
                    style="width: 100%; height: 45rem">
                </GmapMap>
            </div>
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>
import constantes from '@/utils/ConstantesGlobais'
import VuesticTooltip from '@/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip'
import MetodosGlobais from '@/utils/MetodosGlobais'
import mapaDeCalor from '@/services/MapaDeCalor'
import _ from 'lodash'
import iframeBI from '@/components/iframe/implementacoes/iframeBI'
import AutoUpdate from '@/services/AutoUpdate'
import Overlay from '@/assets/geojson/spoverlay'
import { gmapApi } from 'vue2-google-maps'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'


export default {
  name: 'transito-dashboard',
  mixins: [AutoUpdate, Overlay],
  components: {
    VuesticTooltip, Sp360Panel,
  },

  data: () => ({
    dados: {},
    chartData: {},
    bChartData: {},
    options: {},
    congestionamentos: {},
    isColapsado: false,
    tooltipOptions: {
      content: '',
      placement: 'top',
    },
    center: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER,
    zoom: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM,

  }),

  created () {
    this.buscarCongestionamentos()
    this.autoUpdate(this.buscarCongestionamentos, null, 'buscarCongestionamentos', null, 300000, false)
  },
  mounted () {
    this.tooltipOptions.content = this.$t('mobilidade.tooltipCongestionamento')
    this.iniciaGmap()
  },

  methods: {
    buscarLinkBi () {
      this.$store.dispatch('iframeDashboard/buscarUrlIframe', { nome: constantes.LINK_IFRAME.MOBILIDADE.MAPA_TRANSITO })
        .then((retorno) => {
          this.fonte = retorno.data.url
        }).catch((error) => {
          console.error(error)
        })
    },

    buscarCongestionamentos () {
      this.$store.dispatch('mobilidade/buscarCongestionamentosPorVia')
        .then((retorno) => {
          this.congestionamentos = this.processarDados(retorno.data.data)
        })
    },

    processarDados (congestionamentos) {
      if (congestionamentos.length) {
        congestionamentos = _.orderBy(congestionamentos, 'tamanho_m', 'desc')
        let maior_valor = congestionamentos[0].tamanho_m
        for (let con of congestionamentos) {
          con.tamanho_processado = (con.tamanho_m * 100) / maior_valor
          con.legenda = (con.tamanho_m / 1000) + 'km'
        }
        return congestionamentos.slice(0, constantes.PARAMETROS_DASHBOARD.MOBILIDADE.QTD_DE_LOCAIS_CONGESTIONADOS)
      }
    },

    toggleColapsado () {
      this.isColapsado = !this.isColapsado
    },

    iniciaGmap () {
      this.center = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER
      this.zoom = constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM
      this.$refs.gmap.$mapPromise.then((map) => {
        let trafficLayer = new google.maps.TrafficLayer()
        trafficLayer.setMap(map)
        // map.data.loadGeoJson();
        map.data.addGeoJson(this.getGeoJsonLayer())
        // Setando o estilo pro Polygon
        map.data.setStyle({
          /* fillColor: 'green', */
          strokeWeight: 0,
        })
      })
    },

  },
}
</script>

<style lang="scss">

  .widget.chart-widget {
    .widget-body {
      height: 550px;
    }
  }

  .va-progress-bar__info:not(:empty) {
    margin-bottom: 0 !important;
  }

  .wrapperMobPrinc {
      width: 40%;
      height: 40%;
      float: right;
      position: absolute;
  }

  .componente {
      margin-right: 10px;
      padding-top: 5px;
  }

  .va-scrollbar {
      position: relative;
      height: 400px;

    .scrollbar-wrapper {
      box-shadow: none;
    }

  }

  .divTransparente {
      z-index: 1;
      position: absolute;
      top:0;
      left: 70%;
      height: 60%;
      width: 30%;
      background: rgba(0, 0, 0, 0.75);
      border-radius: 25px;
      min-height: 480px;
      max-height: 480px;
  }
  .divColapsada {
      z-index: 1;
      position: absolute;
      top:0;
      left: 70%;
      height: 7%;
      width: 30%;
      background: rgba(0, 0, 0, 0.75);
      border-radius: 25px;
      min-height: 60px;
  }

  .textDivInfo {
      color: white;
      margin: 10px 10px 10px 10px;
  }

  #tituloMob {
      text-align: center;
      text-decoration: underline;
      cursor: pointer;
      margin-bottom: 20px;
      margin-top: 20px;
  }

  .tituloProgress {
      margin-top: 10px;
  }

  @media (min-width: 1275px) and (max-width: 1500px) {
    .va-scrollbar {
      position: relative;
      height: 430px;

    }
    .divTransparente {
        z-index: 1;
        position: absolute;
        top:0;
        left: 70%;
        height: 100%;
        width: 30%;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 25px;
    }
    .divColapsada {
        z-index: 1;
        position: absolute;
        top:0;
        left: 70%;
        height: 7%;
        width: 30%;
        background: rgba(0, 0, 0, 0.75);
        border-radius: 25px;
    }

    #tituloMob {
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 5px;
        margin-top: 5px;
    }

  }

  @media (max-width: 1274px) {
    .divTransparente {
        z-index: 1;
        position: relative;
        bottom:0;
        background: none;
        left: 0;
        height: 100%;
        width: 100%;
    }

    .divColapsada {
        text-align: center;
        z-index: 1;
        position: relative;
        background: none;
        top:0;
        left: 70%;
        height: 10px;
        width: 30%;
    }

    #tituloMob {
        text-align: center;
        text-decoration: underline;
        cursor: pointer;
        margin-bottom: 20px;
        margin-top: 5px;
    }
    .textDivInfo {
        color: black;
        margin: 10px 10px 10px 10px;
     }
    .tituloProgress {
        margin-top: 10px;
    }
  }
</style>
